var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2754 34V31.75C28.3421 31.45 27.5587 30.9167 26.9254 30.15C26.2921 29.3833 25.9254 28.5 25.8254 27.5H27.8254C27.9587 28.2167 28.2962 28.8125 28.8379 29.2875C29.3796 29.7625 30.0254 30 30.7754 30H33.7754C34.1921 30 34.5462 30.1458 34.8379 30.4375C35.1296 30.7292 35.2754 31.0833 35.2754 31.5V34H29.2754ZM32.2754 29C31.7254 29 31.2546 28.8042 30.8629 28.4125C30.4712 28.0208 30.2754 27.55 30.2754 27C30.2754 26.45 30.4712 25.9792 30.8629 25.5875C31.2546 25.1958 31.7254 25 32.2754 25C32.8254 25 33.2962 25.1958 33.6879 25.5875C34.0796 25.9792 34.2754 26.45 34.2754 27C34.2754 27.55 34.0796 28.0208 33.6879 28.4125C33.2962 28.8042 32.8254 29 32.2754 29ZM22.2754 26C22.2754 23.5 23.1504 21.375 24.9004 19.625C26.6504 17.875 28.7754 17 31.2754 17V19C29.3254 19 27.6712 19.6792 26.3129 21.0375C24.9546 22.3958 24.2754 24.05 24.2754 26H22.2754ZM26.2754 26C26.2754 24.6167 26.7629 23.4375 27.7379 22.4625C28.7129 21.4875 29.8921 21 31.2754 21V23C30.4421 23 29.7337 23.2917 29.1504 23.875C28.5671 24.4583 28.2754 25.1667 28.2754 26H26.2754ZM15.2754 23V20.5C15.2754 20.0833 15.4212 19.7292 15.7129 19.4375C16.0046 19.1458 16.3587 19 16.7754 19H19.7754C20.5254 19 21.1712 18.7625 21.7129 18.2875C22.2546 17.8125 22.5921 17.2167 22.7254 16.5H24.7254C24.6254 17.5 24.2587 18.3833 23.6254 19.15C22.9921 19.9167 22.2087 20.45 21.2754 20.75V23H15.2754ZM18.2754 18C17.7254 18 17.2546 17.8042 16.8629 17.4125C16.4712 17.0208 16.2754 16.55 16.2754 16C16.2754 15.45 16.4712 14.9792 16.8629 14.5875C17.2546 14.1958 17.7254 14 18.2754 14C18.8254 14 19.2962 14.1958 19.6879 14.5875C20.0796 14.9792 20.2754 15.45 20.2754 16C20.2754 16.55 20.0796 17.0208 19.6879 17.4125C19.2962 17.8042 18.8254 18 18.2754 18Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24681",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24681",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referral-icon.33e17bb0ea26f214fc20a42dc0cfcc85.svg";
export { ForwardRef as ReactComponent };